<template>
  <nav-bar title="组织架构" />
  <Content :bottom="0">
    <Loading v-if="showLoading && firstLoading" :isLoading="isLoading" @reload="getOrganizationalStructure" />
    <organizational-menu :list="organizationalList" @select="onSelect"/>
  </Content>
  <!-- 添加人员 -->
  <add-personnel ref="addPersonnel" @submit-values="values => handleAddPersonnelSubmit({...values, companyId, roleId}) " :roleId="roleId"  :fillPerson="isFill"/>
  <!-- 添加编辑销售部 -->
  <add-edit-sales-department ref="salesDepartment" :title="title" :goodsList="goodsList" @submit-values="handleSalesDepartmentSubmit" />
  <!-- 添加编辑销售组 -->
  <add-edit-sales-group ref="salesGroup" :title="title" :departId="itemId" :companyId="companyId" @submit-values="handleSalesGroupSubmit" />
</template>

<script>
import { ref, watch } from 'vue'
import AddEditSalesDepartment from './components/AddEditSalesDepartment.vue'
import AddEditSalesGroup from './components/AddEditSalesGroup.vue'
import {
  getCompanyOrgList,
  addCompanyEmp,
  delCompanyAdmin,
  getAllGoods,
  addCompanyDept,
  getDeptInfo,
  editCompanyDept,
  addCompanyGroup,
  editCompanyGroup,
  getGroupInfo
} from '@/api/chome'
import { useAddPersonnel } from '@/hooks/useAddPersonnel'
import { useDelPersonnel } from '@/hooks/useDelPersonnel'
import { useGetData } from '@/hooks/useGetData'
import { useGetDataLoading } from '@/hooks/useGetDataLoading'
import { useSubmit } from '@/hooks/useSubmit'

export default {
  name: 'OrganizationalStructure2', // 组织架构
  components: { AddEditSalesDepartment, AddEditSalesGroup },
  props: ['companyId'],
  provide: {
    hideOperation: false
  },
  setup (props) {
    // 操作（...新增  删除）
    const title = ref('')
    const salesDepartment = ref(null)
    const salesGroup = ref(null)
    const roleId = ref('')
    const operation = ref('') // 操作方式
    const itemId = ref('') // 销售部ID
    const deptInfo = ref({}) // 销售部信息
    const isFill = ref(false) // 是否为充装人员
    const onSelect = ({ action, item }) => {
      const { type } = action
      const { flag, id } = item
      roleId.value = item.roleId
      operation.value = type
      itemId.value = id
      firstLoading.value = false
      if (roleId.value === '3') {
        isFill.value = true
      } else {
        isFill.value = false
      }
      switch (type) {
        case 'add': // 添加
          switch (flag) {
            case 'p':
              // 添加人员
              handleAddPersonnelClick()
              break
            case 'o':
              title.value = '添加销售部'
              salesDepartment.value.showPopup()
              break
            case 'od':
              title.value = '添加销售组'
              salesGroup.value.showPopup()
              break
          }
          break
        case 'edit': // 编辑
          switch (flag) {
            case 'od':
              title.value = '编辑销售部'
              salesDepartment.value.showPopup()
              // 获取销售部信息
              useGetData(getDeptInfo, (data) => {
                deptInfo.value = data
                const { name, seq, goodList } = data
                const state = salesDepartment.value.state
                state.name = name
                state.seq = seq
                state.groupChecked = goodList.map(item => item.goodsId)
              })({ deptId: id })
              break
            case 'og':
              title.value = '编辑销售组'
              salesGroup.value.showPopup()
              // 获取销售组信息
              useGetData(getGroupInfo, (data) => {
                deptInfo.value = data
                const { name, seq, empList, numPlates } = data
                const state = salesGroup.value.state
                state.name = name
                state.seq = seq
                state.numPlates = numPlates
                salesGroup.value.personnelList = empList
              })({ deptId: id })
              break
          }
          break
        case 'del': // 删除
          if (flag === 'p') {
            handleDelPersonnelClick(item.id)
          }
          break
      }
    }
    // 添加人员
    const { addPersonnel, handleAddPersonnelClick, handleAddPersonnelSubmit } = useAddPersonnel(addCompanyEmp, () => {
      getOrganizationalStructure()
    })

    // 删除人员
    const { handleDelPersonnelClick } = useDelPersonnel(delCompanyAdmin, () => {
      getOrganizationalStructure()
    })

    // 获取商品列表
    const goodsList = ref([])
    useGetData(getAllGoods, (data) => {
      goodsList.value = data
    })(props.companyId)

    // 获取组织架构数据
    const organizationalList = ref([])
    const firstLoading = ref(true)
    const { getDataLoading, showLoading, isLoading } = useGetDataLoading(getCompanyOrgList, (data) => {
      organizationalList.value = data
    }, { companyId: props.companyId })
    const getOrganizationalStructure = getDataLoading
    getOrganizationalStructure()

    // 添加编辑销售部
    const handleSalesDepartmentSubmit = (values) => {
      const base = {
        companyId: props.companyId,
        companyLevel: '1',
        parentId: '0',
        ...values
      }
      const method = operation.value === 'add' ? addCompanyDept : editCompanyDept
      const params = operation.value === 'add' ? base : { ...base, id: itemId.value }
      const { loading, onSubmit } = useSubmit(method, params, () => {
        salesDepartment.value.hidePopup()
        getOrganizationalStructure()
      })
      watch(loading, (val) => {
        salesDepartment.value.loading = val
      })
      onSubmit()
    }

    // 添加编辑销售组
    const handleSalesGroupSubmit = (values) => {
      const base = {
        companyId: props.companyId,
        companyLevel: '2',
        ...values
      }
      const method = operation.value === 'add' ? addCompanyGroup : editCompanyGroup
      const params = operation.value === 'add' ? { ...base, parentId: itemId.value } : { ...base, id: itemId.value }
      const { loading, onSubmit } = useSubmit(method, params, () => {
        salesGroup.value.hidePopup()
        getOrganizationalStructure()
      })
      watch(loading, (val) => {
        salesGroup.value.loading = val
      })
      onSubmit()
    }

    return {
      showLoading,
      isLoading,
      getOrganizationalStructure,
      onSelect,
      firstLoading,
      addPersonnel,
      organizationalList,
      roleId,
      handleAddPersonnelSubmit,
      salesDepartment,
      salesGroup,
      title,
      goodsList,
      handleSalesDepartmentSubmit,
      handleSalesGroupSubmit,
      itemId,
      isFill
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
